const content = {
  company: {
    name: "Sijelly IT GmbH",
    address: "Löningstr. 35",
    city: "28195 Bremen",
    phone: "01577-9200456",
    email: "iho@sijelly.it",
    mapsUrl:
      "https://www.google.de/maps/place/Löningstraße+35,+28195+Bremen/@53.0796964,8.8135418,17z",
  },

  hero: {
    headline: "Sijelly IT GmbH",
    subline: "Ihr Partner für IT-Consulting, Testmanagement & Programm Management",
    tags: [
      "Senior Projektleiter",
      "Programm Manager",
      "Senior Test Manager",
      "Scrum Master",
      "Testautomatisierung",
      "Website-Erstellung",
    ],
  },

  services: [
    {
      id: "consulting",
      title: "Consulting",
      description:
        "Wir haben tiefes Know-how im gesamten Software-Lebenszyklus mit agiler und klassischer Vorgehensweise.",
      image: "/images/AdobeStock_602385731-p-800.png",
    },
    {
      id: "testmanagement",
      title: "Testmanagement",
      description:
        "Umfassende Teststrategien, Testkonzepte, Testplanung — von manuell bis hin zur Testautomatisierung mit methodischem Ansatz bei agiler und klassischer Vorgehensweise.",
      image: "/images/AdobeStock_611117124-p-800.png",
    },
    {
      id: "programm-management",
      title: "Programm Management",
      description:
        "Projekte zusammenfassen, Programme leiten, Konzipieren, Organisieren und Überwachen übergreifender Projekte.",
      image: "/images/AdobeStock_389391783-p-800.png",
    },
  ],

  team: [
    {
      id: 1,
      name: "Ingvar Holthey",
      role: "Programm- / Projekt- / Test-Manager",
      image: "/images/bildschirmfoto-2020-07-18-um-02.07.30-602x821.png",
      availability: "Verfügbar ab 01.07.2026",
      phone: "01577-9200456",
      email: "iho@sijelly.it",
      cvSlug: "IHO",
      tags: ["Senior Projektleiter", "Programm Manager", "Senior Testmanager"],
      experience: {
        summary:
          "Programm-, Projekt-, Test-Management\nVersicherung, Financial Sector, ERP Systeme\nTechnische Expertisen/Erfahrungen:",
        skills: [
          "Integration MS NAVISION, Guidewire (Policy-, Claims-, Billing-Center, CM/AB) — Tools (MF ALM, Testrail, JIRA)",
          "Datenbankmanagementsysteme (DB2, Adabas)",
          "Sprachen (PL1, Cobol, SQL-basierte Sprachen)",
          "Plattformen (Windows, MVS, SAP, C/S, MS Dynamics)",
          "Methoden: Agile, IPMA und PMI basierende PM Frameworks, V-Modell XT",
        ],
      },
      projects: [
        "abcfinance Leasing: Projektleitung Vollmigration/Einführung NAV2015 und Leasing Lösung inkl. FIBU, REFI, Jahresbudget 20 Mio €, max. 50 MA & 100 Tester, Laufzeit 2 Jahre",
        "Zurich Versicherung: Projektleitung/Testmanager Guidewire Integration von 150 Schnittstellen, Jahresbudget ca. 12 Mio €, max. 150 MA, Laufzeit 2 Jahre",
        "Dataport: E-Government Rahmenvertrag: Programmleitung/Delivery Verantwortlicher CSC, Jahresbudget 4 Mio €, ca. 30-40 MA, Laufzeit 3,5 Jahre",
        "Neue Commerzbank: Programmleitung Release Cluster 'Dokumentäres Auslandsgeschäft', Jahresbudget 4 Mio €, ca. 40 MA, Laufzeit 3 Jahre",
        "DGHYP Investoren/MBS Retail: Projektleiter SAP Schnittstellen und Entwicklung, Transportmanager",
        "LBSNEU: Teilprojektleitung Migration und Schnittstellen, SAP E-Commerce ERP, Laufzeit 5 Jahre",
        "Deutscher Ring LV AG: Projektleiter Neuentwicklung Gruppeninkassoverwaltung, Rentenverwaltungssystem, Laufzeit 9 Jahre",
      ],
      languages: ["Deutsch", "Englisch"],
    },
    {
      id: 2,
      name: "Lennard Borst",
      role: "Tester / Fullstack-Entwickler / Webentwickler",
      image: "/images/lennard-borst.png",
      availability: "Verfügbar",
      phone: "+4915734100630",
      email: "Lbo@sijelly.it",
      cvSlug: "LBO",
      tags: [
        "E2E Tester",
        "Flutter Entwickler",
        "React Entwickler",
        "Webentwickler",
      ],
      experience: {
        summary:
          "Praktische Erfahrung in der Web- und App-Entwicklung, im Testen sowie in der Programmierung. Fokus auf moderne Technologien und effiziente, benutzerfreundliche Lösungen.",
        skills: [
          "Flutter / Dart (Level A, 4 Jahre)",
          "HTML/CSS (Level A, 5 Jahre)",
          "Figma (Level A, 3 Jahre)",
          "Webflow (Level A, 4 Jahre)",
          "JavaScript / Node.js (2 Jahre)",
          "React (1 Jahr)",
          "Python / FastAPI (1 Jahr)",
          "MariaDB (2 Jahre)",
          "Docker / Terraform (1 Jahr)",
          "Selenium (1 Jahr)",
          "JIRA / XRay, Trello, GitHub, SCRUM",
          "PSLife (Testen, >1 Jahr)",
        ],
      },
      education: [
        "2024: Mitarbeiter bei Sijelly IT GmbH",
        "2022: Selbstständig als Web und App Developer",
        "2021: Hochschule Wismar — Angewandte Informatik",
        "2018: Hochschule Wismar — Wirtschaftsinformatik",
        "2017: Höhere Handelsschule Hamburg-Harburg",
        "2015: Fachhochschulreife, Erich-Kästner-Realschule",
      ],
      certifications: [
        "ISTQB Tester Foundation Level (in Vorbereitung)",
      ],
      workExperience: [
        {
          title: "Sijelly IT GmbH (Mär. 2024 — derzeit)",
          tasks: [
            "Mitarbeit im Projekt Adesso FLH als Tester mit Fokus auf Testdurchführung",
            "IT-Consulting und Programmierung",
            "Verantwortlich für Webentwicklung, Serveradministration und IT-Lösungen",
            "API-Anbindungen und externe Zugriffslösungen",
            "Umsetzung von Kundenprojekten, darunter Licht- und Zugangsteuerungen",
            "Entwicklung eines Auswertungstools für Bankumsätze",
            "Betreuung und Weiterentwicklung der Firmenwebsite",
          ],
        },
        {
          title: "Selbstständig (Sep. 2021 — Mär. 2024)",
          tasks: [
            "Erstellung von Apps und Webseiten für Unternehmen",
            "Entwicklung und Veröffentlichung eigener Apps",
          ],
        },
      ],
      projects: [
        "RunOff Projekt / Insure Platform (02/2025 — 01/2026): Tester (E2E Tests) — Einführung von Adesso Insure Produkten (PSLife, Paytras, Penpay, Commission, Govi). E2E-Testfälle in JIRA/XRAY, Schnittstellenprüfung, Dokumentenprüfung, Release- und Abnahmetests. Tools: JIRA, XRAY, PGAdmin, Java",
        "CSV zu Excel Konverter (04/2024 — laufend): Entwickler — Python-Tool zur automatisierten Verarbeitung von Bankdaten-CSV. Rechnungserkennung mit OCR. Tools: Python, Pandas, openpyxl",
        "Digitale Verwaltungs-Apps Inventur & Vereinsausweise (06/2023 — laufend): Fullstack-Entwickler — Mobile Apps mit Barcode-Scanning, QR-Codes, Echtzeit-Datenabgleich. Tools: Flutter, Dart, Figma, JavaScript, Firebase",
        "Webprojekte Frontend & CMS (01/2023 — laufend): Webentwickler / UI Designer — Responsive Webanwendungen mit React, Webflow, JavaScript. Tools: React, Webflow, JavaScript, Figma, CSS",
      ],
      languages: ["Deutsch (Muttersprache)", "Englisch (Gut)"],
    },
  ],

  impressum: {
    intro:
      "Sijelly IT GmbH\nLöningstr. 35\n28195 Bremen\nTelefon: 01577-9200456\nE-Mail: iho@sijelly.it",
    datenschutz: [
      {
        title: "Haftungshinweis",
        content:
          "Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.",
      },
      {
        title: "Rechtliche Hinweise",
        content:
          "Sijelly IT GmbH bemüht sich, auf dieser Website nur vollständige und richtige Informationen zu veröffentlichen, wir können aber keine Haftung oder Garantie für Aktualität, Richtigkeit und Vollständigkeit der Informationen übernehmen. Sijelly IT GmbH behält sich das Recht vor, Änderungen oder Ergänzungen der angebotenen Informationen vorzunehmen.\n\nEine Haftung für Inhalte außerhalb unserer Webseite, auf die mittels Hyperlink verwiesen wird, ist ausgeschlossen.",
      },
      {
        title: "Privatsphäre und Datenschutz",
        content:
          "Sijelly IT GmbH verpflichtet sich, Ihre Privatsphäre zu schützen und zu respektieren. Diese Datenschutzerklärung beschreibt, wie wir Ihre persönlichen Daten verwenden, verarbeiten und speichern dürfen.\n\nDie Gesetze, die personenbezogene Daten in Deutschland regeln, sind:\n• Bundesdatenschutzgesetz BDSG (neu) 2018\n• VERORDNUNG (EU) 2016/679 (DSGVO)",
      },
      {
        title: "Kennzeichenschutz",
        content:
          "Soweit wir auf unseren Webseiten markenrechtlich oder in ähnlicher Weise geschützte Bezeichnungen Dritter verwenden, geschieht dies nicht zur Kennzeichnung unserer Produkte und/oder Dienstleistungen.",
      },
      {
        title: "Cookies",
        content:
          "Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben.",
      },
    ],
  },
};

export default content;
